import { Component, Output, EventEmitter,Input, OnInit} from '@angular/core';
import { RequestStatus } from '../../interfaces/status.interface'

@Component({
    selector: 'cargoes-action-component',
    template: `     
    <button nz-button nz-dropdown [nzDropdownMenu]="menu" >
      <i nz-icon nzType="more"></i>
    </button> 
    <nz-dropdown-menu #menu="nzDropdownMenu">
      <ul nz-menu nzSelectable>
        <li nz-menu-item *ngIf="defaultData.status && defaultData.status != requestStatus.Draft">
          <a (click)="editRequest(defaultData)">
            <i nz-icon nzType="eye" nzTheme="outline"></i>
            {{'app.action.preview' | translate}}
          </a>
        </li>
        <li nz-menu-item *ngIf="defaultData.status && defaultData.status == requestStatus.Draft">
          <a (click)="editRequest(defaultData)">
            <i nz-icon nzType="edit" nzTheme="outline"></i>
            {{'app.action.update' | translate}}
          </a>
        </li>
        <li nz-menu-item *ngIf="defaultData.status === undefined && update.observers !== undefined && update.observers.length>0">
          <a (click)="editRequest(defaultData)">
            <i nz-icon nzType="edit" nzTheme="outline"></i>
            {{'app.action.update' | translate}}
          </a>
        </li>
        <li nz-menu-item *ngIf="delete && defaultData.status && defaultData.status == requestStatus.Draft">
          <a nz-popconfirm  nzPopconfirmTitle="{{'sez.confirmDeletion' | translate}}" nzPopconfirmPlacement="bottom"
          (nzOnConfirm)="deleteRequest(defaultData)"><i nz-icon nzType="delete" nzTheme="outline"></i> {{'app.action.delete' | translate}}</a>
        </li>
        <li nz-menu-item *ngIf="defaultData.status === undefined && delete.observers !== undefined && delete.observers.length>0">
          <a nz-popconfirm nzPopconfirmTitle="{{'sez.confirmDeletion' | translate}}" nzPopconfirmPlacement="bottom"
          (nzOnConfirm)="deleteRequest(defaultData)"><i nz-icon nzType="delete" nzTheme="outline"></i> {{'app.action.delete' | translate}}</a>
        </li>
      </ul>
    </nz-dropdown-menu>
    `
})
export class TableActionsComponent implements OnInit{

    @Input() defaultData:any;
    requestStatus = RequestStatus;
    @Output() update = new EventEmitter<any>();
    @Output() delete = new EventEmitter<any>();

    constructor() {
    }

    ngOnInit(): void {
    
    }

    deleteRequest(obj:any){
        this.delete.emit(obj);
    }

    editRequest(obj:any){
        this.update.emit(obj)
    }

}
